// extracted by mini-css-extract-plugin
export default {"notFoundContent":"NotFound_notFoundContent__tlQR6","bgGrey":"NotFound_bgGrey__flTjv","sadFace":"NotFound_sadFace__P3rfl"};